import { Component, inject, OnInit, OnDestroy } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import * as Msal from '@azure/msal-browser'
import { FooterComponent } from '../components/footer.component'
import { HeaderComponent } from '../components/header/header.component'
import { AuthService } from '../services/auth.service'
import { LoginComponent } from '../components/login/login.component'
import { MsalBroadcastService, MsalService } from '@azure/msal-angular'
import { filter, Subject, takeUntil } from 'rxjs'
import { SideNavComponent } from '../components/side-nav.component'
import { AlertComponent } from '../components/shared/alert.component'

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    SideNavComponent,
    AlertComponent,
  ],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  readonly _destroying$ = new Subject<void>()
  authService = inject(AuthService)
  msalBroadcastService = inject(MsalBroadcastService)
  msalService = inject(MsalService)
  router = inject(Router)

  ngOnInit() {
    this.msalService.handleRedirectObservable().subscribe()
    this.msalService.instance.enableAccountStorageEvents()

    this.msalBroadcastService.msalSubject$.subscribe(
      (result: Msal.EventMessage) => {
        switch (result.eventType) {
          case Msal.EventType.ACCOUNT_ADDED:
          case Msal.EventType.ACCOUNT_REMOVED: {
            if (this.msalService.instance.getAllAccounts().length === 0) {
              this.router.navigateByUrl('/')
            } else {
              this.authService.setLoginDisplay()
            }
            break
          }
          case Msal.EventType.ACQUIRE_TOKEN_SUCCESS: {
            this.authService.checkAndSetActiveAccount()
            break
          }
        }
      }
    )

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: Msal.InteractionStatus) =>
            status === Msal.InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.authService.setLoginDisplay()
        this.authService.checkAndSetActiveAccount()
      })
  }

  ngOnDestroy() {
    this._destroying$.next(undefined)
    this._destroying$.complete()
  }
}
